<template>
  <div class="about-page">
    <!-- 页眉部分 -->
    <Header></Header>

    <!-- 导航菜单 -->
    <Nav></Nav>

    <!-- 英雄区域 -->
    <div class="hero">
      <div class="hero-content">
        <h1>合作企业</h1>
        <p>产学研结合，共创科技未来</p>
      </div>
    </div>

    <div class="main-content">
      <!-- 合作企业分类标签 -->
      <div class="partner-tabs">
        <div
          v-for="tab in tabs"
          :key="tab.key"
          class="partner-tab"
          :class="{ active: activeTab === tab.key }"
          @click="activeTab = tab.key">
          {{ tab.label }}
        </div>
      </div>

      <!-- 内容区域 -->
      <div
        v-for="tab in tabs"
        :key="tab.key + '-content'"
        class="partner-content"
        :class="{ 'is-active': activeTab === tab.key }"
        v-show="activeTab === tab.key">
        <div class="partner-intro">
          <p>{{ tab.intro }}</p>
        </div>

        <div class="partner-list">
          <div
            v-for="partner in tab.partners"
            :key="partner.name"
            class="partner-item">
            <img :src="partner.logo" :alt="partner.name" class="partner-logo" />
            <h3 class="partner-name">{{ partner.name }}</h3>
            <p class="partner-desc">{{ partner.desc }}</p>
            <p class="partner-field">
              <strong>合作领域：</strong>{{ partner.field }}
            </p>
            <p class="partner-period">合作时间：{{ partner.period }}</p>
            <a
              :href="partner.link"
              class="partner-button"
              target="_blank"
              rel="noopener noreferrer">
              查看详情
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- 页脚 -->
    <Footer></Footer>
  </div>
</template>

<script>
// import defaultLogo from "@/assets/default-logo.png";
import Header from "../../components/head.vue";
import Nav from "../../components/nav.vue";
import Footer from "../../components/footer.vue";

import { listPartner } from "../../api/partner";

export default {
  name: "Partners",
  components: { Header, Nav, Footer },
  data() {
    return {
      activeTab: "industry",
      tabs: [
        {
          key: "industry",
          label: "行业企业",
          intro:
            "我们与多家行业领先企业建立了长期稳定的合作关系，共同推动技术创新和产业升级。",
          partners: [],
        },
        {
          key: "tech",
          label: "科技公司",
          intro:
            "我们与创新型科技公司合作，共同探索前沿技术，推动科技成果转化。",
          partners: [],
        },
        {
          key: "research",
          label: "科研机构",
          intro: "我们与国内外知名科研机构保持密切合作，共同开展前沿科学研究。",
          partners: [],
        },
      ],
    };
  },
  methods: {
    async getIndustryList() {
      let UserBelong = {
        category: "industry",
      };
      let res = await listPartner(UserBelong);
      if (res.code === 0) {
        let partnersData = res.rows;
        for (let i = 0; i < partnersData.length; i++) {
          this.tabs[0].partners.push({
            logo: partnersData[i].logoUrl,
            name: partnersData[i].name,
            desc: partnersData[i].description,
            field: partnersData[i].cooperationField,
            period: partnersData[i].cooperationPeriod,
            link: partnersData[i].websiteUrl,
          });
        }
      }
    },
    async getTechList() {
      let UserBelong = {
        category: "tech",
      };
      let res = await listPartner(UserBelong);
      if (res.code === 0) {
        let techsData = res.rows;
        for (let i = 0; i < techsData.length; i++) {
          this.tabs[1].partners.push({
            logo: techsData[i].logoUrl,
            name: techsData[i].name,
            desc: techsData[i].description,
            field: techsData[i].cooperationField,
            period: techsData[i].cooperationPeriod,
            link: techsData[i].websiteUrl,
          });
        }
      }
    },
    async getResearchList() {
      let UserBelong = {
        category: "research",
      };
      let res = await listPartner(UserBelong);
      if (res.code === 0) {
        let researchsData = res.rows;
        for (let i = 0; i < researchsData.length; i++) {
          this.tabs[2].partners.push({
            logo: researchsData[i].logoUrl,
            name: researchsData[i].name,
            desc: researchsData[i].description,
            field: researchsData[i].cooperationField,
            period: researchsData[i].cooperationPeriod,
            link: researchsData[i].websiteUrl,
          });
        }
      }
    },
    toDetail() {},
  },
  mounted() {
    this.getIndustryList();
    this.getTechList();
    this.getResearchList();
  },
};
</script>

<style scoped>
.hero {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="400"><rect width="1200" height="400" fill="%23004080"/><circle cx="200" cy="150" r="50" fill="%23FFD700" opacity="0.3"/><circle cx="800" cy="250" r="80" fill="%23FFD700" opacity="0.2"/><rect x="400" y="100" width="300" height="200" fill="%23FFD700" opacity="0.1"/></svg>');
  background-size: cover;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  padding: 0 20px;
}
.hero-content h1 {
  font-size: 2.5em;
  margin-bottom: 20px;
}
.hero-content p {
  font-size: 1.1em;
}

.main-content {
  max-width: 1000px;
  margin: 40px auto;
  padding: 0 40px;
}

.partner-tabs {
  display: flex;
  justify-content: center;
  flex-wrap: wrap; /* ⬅ 允许换行 */
  margin-bottom: 20px;
  border-bottom: 2px solid #e0e0e0;
}

.partner-tab {
  padding: 14px 28px;
  font-size: 1.05rem;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  white-space: nowrap;
}

.partner-tab.active {
  color: #003366;
  font-weight: 600;
}

.partner-tab.active::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 100%;
  height: 3px;
  background-color: #003366;
  border-radius: 2px;
}

.partner-content {
  display: none;
}
.partner-content.is-active {
  display: block;
}

.partner-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.partner-item {
  flex: 0 1 calc(33.333% - 20px); /* ⬅ 三列布局 */
  max-width: 360px;
  background: #f8f9fa;
  border-radius: 10px;
  padding: 20px;
  margin: 10px;
  transition: transform 0.3s;
  box-sizing: border-box;
}

.partner-item:hover {
  transform: translateY(-5px);
}

.partner-intro p {
  text-align: center;
}

.partner-logo {
  max-width: 120px;
  margin-bottom: 15px;
}

.partner-name {
  color: #004080;
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 10px;
  text-align: center;
}

.partner-desc,
.partner-field,
.partner-period {
  color: #666;
  margin-bottom: 15px;
  font-size: 0.95rem;
  line-height: 1.5;
}

.partner-field {
  font-weight: bold;
  color: #004080;
}

.partner-button {
  display: inline-block;
  margin-top: 15px;
  padding: 8px 20px;
  background-color: #004080;
  color: white;
  border-radius: 4px;
  text-decoration: none;
  transition: 0.3s;
}

.partner-button:hover {
  background-color: #003366;
}

/* ========= 响应式布局 ========= */

/* 平板（小于1200px） */
@media (max-width: 1200px) {
  .partner-item {
    flex: 0 1 calc(50% - 20px); /* ⬅ 两列 */
  }
}

/* 手机（小于768px） */
@media (max-width: 768px) {
  .hero {
    height: 220px;
    padding: 0 15px;
  }
  .hero-content h1 {
    font-size: 2em;
  }
  .hero-content p {
    font-size: 1em;
  }

  .main-content {
    padding: 0 20px;
  }

  .partner-tab {
    padding: 10px 16px;
    font-size: 0.95rem;
  }

  .partner-item {
    flex: 0 1 100%; /* ⬅ 一列 */
    max-width: 100%;
  }

  .partner-logo {
    max-width: 100px;
  }

  .partner-name {
    font-size: 1.1rem;
  }

  .partner-desc,
  .partner-field,
  .partner-period {
    font-size: 0.9rem;
  }
}

/* 超小屏（小于480px） */
@media (max-width: 480px) {
  .hero-content h1 {
    font-size: 1.6em;
  }
  .partner-tab {
    padding: 8px 12px;
    font-size: 0.85rem;
  }
  .partner-button {
    padding: 6px 12px;
    font-size: 0.85rem;
  }
}
</style>
